import { useEffect, useState, useMemo } from 'react';
import './index.css';
import {
  Grid,
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Box,
  Divider,
  Stack,
  FormControl,
  RadioGroup,
  Radio,
  Chip,
} from '@mui/material';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import close from '../../../asset/image/cross.svg';
import _ from 'lodash';
import {
  strToK4List,
  getDecodeURI,
  getTimezoneCity,
  setDateTimeByTimezone,
  getOrdinalSuffix,
} from '../../../utils/util';
import {
  getReportsSubscription,
  createReportsSubscription,
  updateReportsSubscription,
} from '../../../actions/Users/authenticateUsageReports';
import {
  DEFAULT_SCHEDULER_REPORT_TYPES,
  DEFAULT_FREQUENCIES,
  DEFAULT_REPORT_METHODS,
  DEFAULT_SITE_REPORT_TYPES,
  DEFAULT_SL_REPORT_TYPES,
  week_days,
  date_views,
  time_views,
  USER_PREFERENCES,
} from '../../../constants/Constants';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  fetchResources,
  fetchServiceLines,
  getResourcesForOUs,
  getServiceLinesForOUs,
} from '../../../actions/Users/authenticate';
import { getAllServiceLineSubscriptionAPI } from '../../StarlinkDashboard/slice';
import DP_Dropdown from '../../InventoryWarehouseTable/DP_Dropdown';
import Org_Drop_down from '../Org_Drop_down';
import { toast } from 'react-toastify';
import CustomLoader from '../../Loader/CustomLoader';
import moment from 'moment';
import { Moment } from 'moment-timezone';
import DateFilter from '../../ScheduledReport/DateFilter';
import { SelectTimezone } from 'reactjs-timezone-select';
import time_clock from '../../../asset/image/timeClock.svg';
import runReport from '../../../asset/image/runReport.svg';
import clockBlueBg from '../../../asset/image/clockBlueBG.svg';
import CustomizedSwitches from '../Slider';
import DayPicker from '../../CommonComponents/DayPicker';

type ServiceLine = {
  name: string;
  id: string;
};

const regex = /^[a-zA-Z0-9_ -]*$/;
const replace_regex = /[^a-zA-Z0-9_ -]/g;

const AddReportPopup = (props) => {
  const {
    open,
    onClose,
    fetchResources,
    getResourcesForOUs,
    getServiceLinesForOUs,
    authReducer,
    location,
    deviceOu,
    getAllServiceLineSubscriptionAPI,
    showAllServiceLines = false,
    getAllServiceLinesSubscription,
    createReportsSubscription,
    updateReportsSubscription,
    is_report_edit,
    site_admin_access,
    sl_admin_access,
    userTimezone,
    is_copy_report,
  } = props;
  let _q = getDecodeURI(location?.search);
  const [reportTypes, setReportTypes] = useState<any>(
    site_admin_access && !sl_admin_access
      ? [...DEFAULT_SITE_REPORT_TYPES]
      : !site_admin_access && sl_admin_access
        ? [...DEFAULT_SL_REPORT_TYPES]
        : [...DEFAULT_SCHEDULER_REPORT_TYPES],
  );
  const [selectedFrequency, setFrequency] = useState<any>(
    DEFAULT_FREQUENCIES[0],
  );
  const [reportMethods, setReportMethods] = useState([
    ...DEFAULT_REPORT_METHODS,
  ]);
  const [starlinkSelected, setStarlink] = useState(
    site_admin_access && !sl_admin_access
      ? 'No'
      : !site_admin_access && sl_admin_access
        ? 'Yes'
        : 'Both',
  );
  const [_sitesList, setSitesList] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [_serviceLineName, setServiceLineName] = useState<any>([]);
  const [serviceLines, setServiceLines] = useState<any>([]);
  const [reportName, setReportName] = useState('');
  const [selectedOu, setSelectedOu] = useState<any>([]);
  const [report_type_list, setReportTypeList] = useState<any>(
    site_admin_access && !sl_admin_access
      ? [...DEFAULT_SITE_REPORT_TYPES]
      : !site_admin_access && sl_admin_access
        ? [...DEFAULT_SL_REPORT_TYPES]
        : [...DEFAULT_SCHEDULER_REPORT_TYPES],
  );
  const [is_report_editable, setReportEdit] = useState(false);
  const [was_scheduled_on_edit, setWasScheduledOnEdit] = useState(false);
  const [removed_ous, setRemoveOus] = useState<any>([]);
  const [showLoader, setShowLoader] = useState(false);
  const [no_site_sl, setNoSiteSl] = useState(false);
  const today_date = moment(new Date()).utc();
  const tmrw_date = moment(new Date()).add(1, 'days').utc();
  const date = moment(new Date()).subtract(30, 'days').utc();
  const [from_date, setFromDate] = useState<moment.Moment | null>(date);
  const [to_date, setToDate] = useState<moment.Moment | null>(today_date);
  const [start_time, setStartTime] = useState<any>(today_date);
  const [end_time, setEndTime] = useState<moment.Moment | null>(today_date);

  const [scheduled_on, setScheduledOn] = useState<moment.Moment | null>(
    today_date,
  );
  const [description, setDescription] = useState('');
  const [switchScheduler, setSwitchScheduler] = useState(false);
  const [switchEachSite, setSwitchEachSite] = useState(false);
  const starlink_label = { label: 'StarlinkUsage', name: 'Starlink Usage' };

  const [_views, setViews] = useState<any>([...DEFAULT_FREQUENCIES[0].views]);
  const [selWeekDay, setWeekDay] = useState<any>(week_days[0]);

  const [selectedMonthYear, setSelectedMonthYear] = useState(moment());
  const [day, setDay] = useState({
    label: `1${getOrdinalSuffix(1)}`,
    value: 1,
  });
  const daysInMonth = selectedMonthYear.daysInMonth();
  let days = Array.from({ length: 28 }, (_, i) => ({
    label: `${i + 1}${getOrdinalSuffix(i + 1)}`,
    value: i + 1,
  }));
  if (daysInMonth > 28) {
    days.push({ label: 'Last Day', value: daysInMonth });
  }

  const [selectedTimeZone, setSelectedTimeZone] = useState<string>('');
  const [mth_day, setMthDay] = useState<any>(`1${getOrdinalSuffix(1)}`);

  const [summaryText, setSummaryText] = useState<string>('');
  const [reportCounter, setReportCounter] = useState<number>(0);

  const handleDayPicker = (value) => {
    handleDateSelection(value, selectedMonthYear);
  };

  const handleDateSelection = (date, monthYear) => {
    const formattedMonthYear = monthYear.format('YYYY-MM');
    let today = moment(new Date()).format('DD');
    let label =
      date === selectedMonthYear.daysInMonth()
        ? 'Last Day'
        : `${date}${getOrdinalSuffix(date)}`;
    setDay({
      label: label,
      value: date,
    });
    setMthDay(label);
    setSelectedMonthYear(monthYear);
    let startDate = moment(`${formattedMonthYear}-${date}`, 'YYYY-MM-DD');
    // check condition
    if (startDate.isSameOrBefore(today, 'day')) {
      startDate = startDate.add(1, 'month');
    }
    setFromDate(startDate);
  };

  useEffect(() => {
    let report_types = [...reportTypes];
    report_types = report_types.filter((type) => type.label !== 'All');
    setReportCounter(report_types.length);
  }, [reportTypes]);

  useEffect(() => {
    let dt1 = from_date;
    if (switchScheduler) {
      dt1 = today_date;
      if (
        !selectedFrequency ||
        selectedFrequency == undefined ||
        Object.keys(selectedFrequency).length === 0
      )
        setFrequency(DEFAULT_FREQUENCIES[0]);
    } else dt1 = date;
    setFromDate(dt1);
  }, [switchScheduler]);

  useEffect(() => {
    if (!_.isEmpty(authReducer.userTimezone)) {
      try {
        setSelectedTimeZone(authReducer.userTimezone);
        let timezone = authReducer.userTimezone.split(' - ')[0];
        let dte = moment().tz(timezone);
        setStartTime(dte);
      } catch (err) {}
    }
  }, [authReducer.userTimezone]);

  useEffect(() => {
    getSummaryText();
  }, [
    selectedFrequency,
    switchScheduler,
    selectedTimeZone,
    start_time,
    from_date,
    selWeekDay,
    mth_day,
  ]);

  const getSummaryText = () => {
    let txt = ``;
    if (switchScheduler) {
      let _time = moment(start_time);
      let strt_time = _time.format('HH:mm');
      let timezone = selectedTimeZone.split(' - ')[1];
      let end_tme = moment(_time.format('YYYY-MM-DD HH:mm'))
        .subtract(1, 'second')
        .format('HH:mm:ss');
      let strt_tme = _time.format('HH:mm:00');
      let freq = selectedFrequency?.label;
      let _date = moment(from_date);
      let to_date = _date.format('DD-MMM-YYYY');
      let frm_date = _date.subtract(1, 'months').format('DD-MMM-YYYY');

      switch (freq) {
        case 'daily':
          txt = `Runs daily at ${strt_time} ${timezone}. Includes data from the last 24 hours (till ${end_tme}).`;
          break;
        case 'weekly':
          txt = `Runs every ${selWeekDay.name} at ${strt_time} ${timezone}. Includes data from the last 7 days (till ${strt_tme} - 1 sec).`;
          break;
        case 'monthly':
          txt = `Runs on the ${mth_day} of every month at ${strt_time} ${timezone}. Includes data from the previous month (${frm_date} ${strt_tme} of last month - ${to_date} ${end_tme})`;
          break;
        default:
          txt = ``;
      }
    }
    setSummaryText(txt);
  };

  useEffect(() => {
    if (
      is_report_edit &&
      is_report_edit !== undefined &&
      Object.keys(is_report_edit).length
    ) {
      console.log('is_report_edit', is_report_edit);
      setReportEdit(true);
      let name = is_report_edit.name;
      if (is_copy_report) name = '';
      setReportName(name);
      setReportTypes([...is_report_edit._type]);
      setFrequency(is_report_edit._freq[0]);
      if (is_report_edit._freq[0]?.views.length)
        setViews([...is_report_edit._freq[0].views]);
      setDescription(is_report_edit.description);
      handleStarlinkSelected(is_report_edit._type, true);
      let is_recurring = is_report_edit?.category == 'Scheduled' ? true : false;
      setSwitchScheduler(is_recurring);
      setWasScheduledOnEdit(is_recurring);
      let is_per_site = is_report_edit?.scope == 'PER_SITE' ? true : false;
      setSwitchEachSite(is_per_site);
      let time_zone = is_report_edit?.report_timezone
        ? is_report_edit.report_timezone
        : selectedTimeZone;
      let timezone = time_zone.split(' - ')[0];
      setSelectedTimeZone(time_zone);
      if (is_report_edit?.from_date && is_report_edit?.to_date) {
        let frm_dte = moment(new Date(is_report_edit.from_date)).utc();
        let to_dte = moment(new Date(is_report_edit.to_date)).utc();
        setFromDate(frm_dte);
        setToDate(to_dte);
        setStartTime(moment(frm_dte).tz(timezone));
        setEndTime(to_dte);
      }

      if (is_report_edit?.scheduled_on) {
        let sch_on_tz = moment.utc(is_report_edit.scheduled_on).tz(timezone);
        let wk_day = sch_on_tz.day();
        setScheduledOn(sch_on_tz);
        setStartTime(sch_on_tz);
        if (is_report_edit._freq[0].label == 'weekly') {
          let sel_day = week_days.find((e) => e.label == wk_day);
          if (sel_day) setWeekDay(sel_day);
        }
        if (
          is_report_edit._freq[0].label == 'monthly' &&
          is_report_edit.schedule_day !== undefined &&
          is_report_edit.schedule_day !== null
        ) {
          const scheduleDay = is_report_edit.schedule_day;
          if (scheduleDay === 0) {
            const lastDay = selectedMonthYear.daysInMonth();
            setDay({ label: 'Last Day', value: lastDay });
            setMthDay('Last Day');
          } else {
            const label = `${scheduleDay}${getOrdinalSuffix(scheduleDay)}`;
            setDay({ label, value: scheduleDay });
            setMthDay(label);
          }
        }
      }

      // if (is_report_edit?._sline?.length)
      //   setServiceLines([...is_report_edit._sline]);
      // if (is_report_edit?._site?.length) setSites([...is_report_edit._site]);
      if (is_report_edit.orgs_id?.length) setSelectedOu(is_report_edit.orgs_id);
    }
  }, [is_report_edit, is_report_editable]);

  useEffect(() => {
    let _nositesl = false;
    if (_sitesList?.length === 0 && _serviceLineName?.length === 0)
      _nositesl = true;
    setNoSiteSl(_nositesl);
  }, [_sitesList, _serviceLineName]);

  const handleOu = (ou: any) => {
    let _selected_ou = [...selectedOu];
    let removed_ous = _selected_ou.filter((dp) => !ou.includes(dp));
    setRemoveOus(removed_ous);
    setSelectedOu(ou);
    if (ou?.length) {
      setShowLoader(true);
      if (site_admin_access && !sl_admin_access)
        getResourcesForOUs({ ouIds: ou });
      else if (!site_admin_access && sl_admin_access)
        getServiceLinesForOUs({ ouIds: ou });
      else if (site_admin_access && sl_admin_access) {
        getResourcesForOUs({ ouIds: ou });
        getServiceLinesForOUs({ ouIds: ou });
      }
    }
  };

  useEffect(() => {
    setShowLoader(true);
    if (!_.isEmpty(authReducer?.fetchSiteList)) {
      let resourceRecords = authReducer.fetchSiteList?.data;
      if (resourceRecords && Array.isArray(resourceRecords)) {
        let sortedResourceNames: any[] = [];
        if (resourceRecords?.length) {
          sortedResourceNames = resourceRecords.sort((a: any, b: any) => {
            return ('' + a.name).localeCompare(b.name);
          });
          if (removed_ous?.length) {
            let _sel_sites = [...sites];
            let new_sites: any[] = [];
            _sel_sites.map((site) => {
              let is_site = sortedResourceNames.find(
                (vsl) => vsl.siteId === site.siteId,
              );
              if (is_site) new_sites.push(site);
            });
            setSites([...new_sites]);
          }

          let vsl_obj = {
            siteName: 'All Sites',
            siteId: 'All Sites',
          };
          if (
            !sortedResourceNames.some((vsl) => vsl.siteName === 'All Sites')
          ) {
            sortedResourceNames.unshift(vsl_obj);
            if (!is_report_editable) setSites([]);
          }
        } else if (!is_report_editable) setSites([]);

        setSitesList(sortedResourceNames);
      } else {
        setSites([]);
        setSitesList([]);
      }
      authReducer.fetchSiteList = {};
    }
    setShowLoader(false);
  }, [authReducer.fetchSiteList]);

  useEffect(() => {
    setShowLoader(true);
    if (!_.isEmpty(authReducer?.fetchServiceLineList)) {
      let serviceLinesData = authReducer.fetchServiceLineList?.data?.length
        ? authReducer.fetchServiceLineList.data
        : [];
      if (serviceLinesData?.length) {
        if (removed_ous?.length) {
          let _sel_sl = [...serviceLines];
          let new_sl: any[] = [];
          _sel_sl.map((sl) => {
            let is_sl = serviceLinesData.find(
              (s_line) => s_line.serviceLineId === sl.serviceLineId,
            );
            if (is_sl) new_sl.push(sl);
          });
          setServiceLines([...new_sl]);
        }
        let externalAllServiceLineObj = {
          serviceLineName: 'All Service Lines',
          serviceLineId: 'All Service Lines',
        };
        if (
          !serviceLinesData.some(
            (serviceLine) =>
              serviceLine.serviceLineName === 'All Service Lines',
          )
        ) {
          serviceLinesData.unshift(externalAllServiceLineObj);
          if (!is_report_editable) setServiceLines([]);
        }
      } else if (!is_report_editable) setServiceLines([]);

      setServiceLineName(serviceLinesData);
    }
    setShowLoader(false);
  }, [authReducer.fetchServiceLineList]);

  useEffect(() => {
    setShowLoader(true);
    if (
      authReducer.fetchServiceLineList &&
      authReducer.fetchServiceLineList.data &&
      authReducer.fetchServiceLineList.data.lenght &&
      getAllServiceLinesSubscription
    ) {
      let serviceLines = authReducer.fetchServiceLineList.data;
      let filteredServiceLines = serviceLines;
      if (!showAllServiceLines) {
        filteredServiceLines = serviceLines.filter((line) =>
          getAllServiceLinesSubscription.some(
            (sub) =>
              sub.service_line_number === line.serviceLineId && sub.active,
          ),
        );
      }

      // if (
      //   !filteredServiceLines.some(
      //     (serviceLine) => serviceLine.name === 'All Service Lines'
      //   )
      // ) {
      //   filteredServiceLines.unshift({
      //     name: 'All Service Lines',
      //     id: 'All Service Lines',
      //   });
      // }
      setServiceLineName(filteredServiceLines);
    }
    setShowLoader(false);
  }, [
    authReducer.fetchServiceLineList,
    getAllServiceLinesSubscription,
    showAllServiceLines,
  ]);

  useEffect(() => {
    if (
      is_report_edit === undefined &&
      Object.keys(is_report_edit).length == 0
    ) {
      let _nositesl = false;
      let rep_list =
        site_admin_access && !sl_admin_access
          ? [...DEFAULT_SITE_REPORT_TYPES]
          : !site_admin_access && sl_admin_access
            ? [...DEFAULT_SL_REPORT_TYPES]
            : [...DEFAULT_SCHEDULER_REPORT_TYPES];

      if (_sitesList?.length === 0 && _serviceLineName?.length) {
        rep_list = [...DEFAULT_SL_REPORT_TYPES];
      } else if (_sitesList?.length && _serviceLineName?.length === 0) {
        rep_list = [...DEFAULT_SITE_REPORT_TYPES];
      } else if (_sitesList?.length === 0 && _serviceLineName?.length === 0) {
        _nositesl = true;
        rep_list = [];
      }
      setNoSiteSl(_nositesl);
      setReportTypes([rep_list?.length ? rep_list[0] : '']);
      setReportTypeList(rep_list);
    }
  }, [_sitesList, _serviceLineName]);

  const handleChangeSite = (e, newValue) => {
    setSites([...newValue]);
  };

  const handleChangeReportTypes = (event, item) => {
    const { checked } = event.target;
    let _reports: any = [...reportTypes];
    if (checked) {
      // If checked, add the value to the array
      if (item.label === 'All') {
        _reports = [...report_type_list];
      } else {
        if (!_reports.find((type) => type.label == item.label))
          _reports.push(item);
      }
    } else {
      // If unchecked, remove the value from the array using filter
      if (item.label === 'All') _reports = [];
      else {
        _reports = _reports.filter((el) => el.label !== 'All');
        _reports = _reports.filter((el) => el.label !== item.label);
      }
    }
    setReportTypes([..._reports]);
    handleStarlinkSelected(_reports);
  };

  const handleChangeFrequency = (e, newValue) => {
    setFrequency(newValue);
    if (newValue?.views?.length) setViews(newValue.views);
    if (newValue?.label === 'monthly') {
      handleDateSelection(day.value, selectedMonthYear);
    }
  };

  const handleWeekDay = (event, week_day) => {
    if (!week_day) {
      setSummaryText('');
      // user clicked clear ❌
      return;
    }

    setWeekDay(week_day);
  };

  const handleStarlinkSelected = (newValue, update = false) => {
    const report = [...newValue];
    let is_starlink_sel = report.find((e) => e.label === 'StarlinkUsage');
    let other_report_sel = report.find((e) => e.label !== 'StarlinkUsage');

    let is_starlink =
      (is_starlink_sel !== undefined && other_report_sel !== undefined) ||
      (other_report_sel !== undefined && other_report_sel.label === 'All')
        ? 'Both'
        : is_starlink_sel === undefined && other_report_sel !== undefined
          ? 'No'
          : is_starlink_sel !== undefined && other_report_sel === undefined
            ? 'Yes'
            : 'No';

    if (starlinkSelected !== is_starlink || update) {
      setStarlink(is_starlink);
      let sl_obj = {
        serviceLineName: 'All Service Lines',
        serviceLineId: 'All Service Lines',
      };

      let vsl_obj = {
        siteName: 'All Sites',
        siteId: 'All Sites',
      };
      let _sl_lines = is_report_edit?._sline?.length
        ? [...is_report_edit._sline]
        : serviceLines?.length
          ? [...serviceLines]
          : _serviceLineName?.length
            ? [sl_obj]
            : [];

      let _sel_sites = is_report_edit?._site?.length
        ? [...is_report_edit._site]
        : sites?.length
          ? [...sites]
          : _sitesList?.length
            ? [vsl_obj]
            : [];
      if (is_starlink == 'No') _sl_lines = [];
      else if (is_starlink == 'Yes') _sel_sites = [];
      setServiceLines([..._sl_lines]);
      setSites([..._sel_sites]);
    }
  };

  const handleInputServiceLineChange = (e, newValue) => {
    const { name, value } = e.target;
    const serviceLines = newValue.map((serviceLine) => ({
      serviceLineName: serviceLine.serviceLineName,
      serviceLineId: serviceLine.serviceLineId,
    }));
    setServiceLines(serviceLines);
  };

  const handleReportName: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    let value = e.target.value;
    let new_val = value.replace(replace_regex, '');
    if (!regex.test(value))
      toast.error(
        `Report Name can have only Alpha numeric,space, undersocre(_) and hyphen(-)`,
        {
          position: toast.POSITION.BOTTOM_LEFT,
        },
      );

    if (value.length > 255)
      toast.error(`Report Name cannot exceed more than 255 characters`, {
        position: toast.POSITION.BOTTOM_LEFT,
      });

    setReportName(new_val);
  };

  const handleDescription: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    let value = e.target.value;
    if (value.length > 1000)
      toast.error(`Description cannot exceed more than 1000 characters`, {
        position: toast.POSITION.BOTTOM_LEFT,
      });

    setDescription(value);
  };

  const handleSaveButton = async (e) => {
    setShowLoader(true);
    try {
      let verified_msg = verifyStateValues();

      if (
        verified_msg &&
        verified_msg !== undefined &&
        verified_msg.trim() !== ''
      )
        toast.error(verified_msg, { position: toast.POSITION.BOTTOM_LEFT });
      else {
        let sites_id: string[] = [];
        if (starlinkSelected !== 'Yes') {
          let _sites = [...sites];
          if (_sites.some((type) => type.siteName === 'All Sites'))
            _sites = [..._sitesList];
          _sites = _sites.filter((type) => type.siteName !== 'All Sites');
          if (_sites?.length) _sites.map((site) => sites_id.push(site.siteId));
        }

        let service_lines_id: string[] = [];
        if (starlinkSelected !== 'No') {
          let _service_line = [...serviceLines];
          if (
            _service_line.some(
              (sl) => sl.serviceLineName === 'All Service Lines',
            )
          )
            _service_line = [..._serviceLineName];
          _service_line = _service_line.filter(
            (type) => type.serviceLineName !== 'All Service Lines',
          );
          if (_service_line?.length)
            _service_line.map((sl) => service_lines_id.push(sl.serviceLineId));
        }

        if (sites_id.length === 0 && service_lines_id.length === 0)
          toast.error(
            `No Site And Service Line for the selected Organization`,
            {
              position: toast.POSITION.BOTTOM_LEFT,
            },
          );
        else {
          let types: string[] = [];
          let report_types = [...reportTypes];
          report_types = report_types.filter((type) => type.label !== 'All');
          if (report_types?.length)
            report_types.map((type) => types.push(type.label));
          else
            report_type_list.map(
              (type) => type.label !== 'All' && types.push(type.label),
            );

          let frequency: string[] =
            selectedFrequency &&
            selectedFrequency !== undefined &&
            Object.keys(selectedFrequency).length
              ? [selectedFrequency.name]
              : [];
          //selectedFrequency.map((frq) => frequency.push(frq.name));
          let payload: any = {};
          payload = {
            name: reportName.trim(),
            // orgs_id:selectedOu,
            sites_id: sites_id,
            service_lines_id: service_lines_id,
            description: description,
            category: switchScheduler ? 'Scheduled' : 'OnDemand',
            report_timezone: selectedTimeZone,
            scope: switchEachSite ? 'PER_SITE' : 'ALL',
          };
          const is_edit = is_report_editable && !is_copy_report;
          // let orgId = is_edit
          //   ? is_report_edit.org_id
          //   : _.isEmpty(deviceOu)
          //   ? authReducer.selectedOu.id
          //   : deviceOu.id;
          let dps_id = selectedOu;
          // let index = dps_id.findIndex((id) => id === orgId);
          // if (index > -1) dps_id.splice(index, 1);
          payload = { ...payload, orgs_id: dps_id };
          if (is_edit) payload = { ...payload, type: types };
          else payload = { ...payload, types: types };
          let strt_time = moment(start_time).format('HH:mm:ss');
          let timezone = selectedTimeZone.split(' - ')[0];
          if (switchScheduler) {
            let _date =
              selectedFrequency.label == 'monthly'
                ? moment(from_date).format('YYYY-MM-DD')
                : selectedFrequency.label == 'weekly'
                  ? moment(
                      setFutureDateByDay(selWeekDay.label, strt_time, timezone),
                    ).format('YYYY-MM-DD')
                  : moment().format('YYYY-MM-DD');

            payload.scheduled_on = convertToUTC(_date, strt_time, timezone);
            payload.frequency = frequency;
            payload.schedule_day =
              selectedFrequency.label == 'daily'
                ? 0
                : selectedFrequency.label == 'weekly'
                  ? selWeekDay.label
                  : mth_day == 'Last Day'
                    ? 0
                    : day.value;
          } else {
            let frm_dte = moment(from_date).format('YYYY-MM-DD');
            let to_dte = moment(to_date).format('YYYY-MM-DD');

            payload.from_date = convertToUTC(frm_dte, strt_time, timezone);
            payload.to_date = convertToUTC(to_dte, strt_time, timezone);
          }
          //console.log('payloadddd', payload);
          let resp = is_edit
            ? await updateReportsSubscription(payload, is_report_edit.id)
            : await createReportsSubscription(payload);
          let call_list_api = false;
          let toast_msg: any = null;
          if (resp && resp.hasOwnProperty('success') && resp.success === true) {
            call_list_api = true;
            toast_msg = `Report ${reportName} successfully `;
            toast_msg += is_edit ? 'updated' : 'added';
          }

          if (onClose) onClose(e, call_list_api, toast_msg);
        }
      }
    } catch (_error) {
      // prevent loader from getting stuck on API failure
    } finally {
      setShowLoader(false);
    }
  };

  function convertToUTC(date, time, timezone) {
    let datetime = `${date} ${time}`;
    return setDateTimeByTimezone(datetime, timezone).utc().format();
  }

  const verifyStateValues = () => {
    let msg: any = null;
    if (!reportName || reportName === undefined || reportName.trim() === '')
      msg = 'Please enter the Report Name';
    else if (!regex.test(reportName))
      msg = `Report Name can have only Alpha-numeric, undersocre(_) and hyphen(-)`;
    else if (reportName.length > 255)
      msg = `Report Name cannot exceed more than 255 characters`;
    else if (!selectedOu || selectedOu === undefined || selectedOu.length === 0)
      msg = 'Please select Organization';
    else if (
      !reportTypes ||
      reportTypes === undefined ||
      reportTypes.length === 0
    )
      msg = 'Please select Type';
    else if (
      site_admin_access &&
      _sitesList?.length &&
      (starlinkSelected === 'No' || starlinkSelected === 'Both') &&
      (!sites || sites === undefined || sites.length === 0)
    )
      msg = 'Please select Site';
    else if (
      sl_admin_access &&
      _serviceLineName?.length &&
      (starlinkSelected === 'Yes' || starlinkSelected === 'Both') &&
      (!serviceLines || serviceLines === undefined || serviceLines.length === 0)
    )
      msg = 'Please select Service Line';
    else if (
      switchScheduler &&
      (!selectedFrequency ||
        selectedFrequency === undefined ||
        Object.keys(selectedFrequency).length == 0)
    )
      msg = `Please select the Frequency`;
    else if (
      !description ||
      description === undefined ||
      description.trim() === ''
    )
      msg = 'Please enter the Report Description';
    return msg;
  };

  function setFutureDateByDay(desiredWeekday, timeStr, timezone) {
    // current time in given timezone
    let now = setDateTimeByTimezone(today_date, timeStr);

    let todayWeekday = now.day();

    // parse time string
    const [hour, minute, second = 0] = timeStr.split(':').map(Number);

    // calculate weekday difference
    let daysToAdd = (desiredWeekday - todayWeekday + 7) % 7;

    // create target time for the desired weekday in timezone
    let targetDateTime = moment
      .tz(timezone)
      .day(desiredWeekday)
      .hour(hour)
      .minute(minute)
      .second(second)
      .millisecond(0);

    // If the calculated time has already passed, move it to next week
    if (!targetDateTime.isAfter(now)) {
      targetDateTime.add(7, 'days');
    }

    // desired weekday is not today
    return now
      .clone()
      .add(daysToAdd, 'days')
      .hour(hour)
      .minute(minute)
      .second(second)
      .millisecond(0);
  }

  const handleFromDatePicker = (date: Moment | null) => {
    if (date) {
      setFromDate(date);
    }
  };

  const handleToDatePicker = (date: Moment | null) => {
    if (date) {
      setToDate(date);
      const timezone = selectedTimeZone.split(' - ')[0];
      const nowInTz = timezone ? moment().tz(timezone) : moment();
      if (!switchScheduler && date.isSame(nowInTz, 'day')) {
        if (moment(start_time).isAfter(nowInTz)) {
          setStartTime(nowInTz.clone());
        }
      }
    }
  };

  const handleStartTimePicker = (date: Moment | null) => {
    if (date) {
      const timezone = selectedTimeZone.split(' - ')[0];
      let dte = moment(date).tz(timezone);
      const nowInTz = timezone ? moment().tz(timezone) : moment();
      const isEndToday =
        !switchScheduler &&
        to_date != null &&
        moment(to_date).isSame(nowInTz, 'day');
      if (isEndToday && dte.isAfter(nowInTz)) {
        dte = nowInTz.clone();
      }
      setStartTime(dte);
    }
  };

  const handleToTimePicker = (date: Moment | null) => {
    if (date) {
      setEndTime(date);
    }
  };

  const handleScheduledOnPicker = (date: Moment | null) => {
    if (date) {
      let sel_time = moment(date).format('HH:mm:ss');
      let cur_time = moment(new Date()).utc().format('HH:mm:ss');
      let msg = '';
      if (sel_time <= cur_time) {
        let tmw_dte = moment(tmrw_date).format('DD-MMM-YYYY');
        msg = `Report is scheduled on ${tmw_dte} at ${sel_time}`;
      }
      setScheduledOn(date);
    }
  };

  return (
    <Dialog
      className='menuScroll'
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth='md'
    >
      <DialogTitle className='invite-user-padding dialog_title'>
        <Grid item container className='inter-font dialog_grid'>
          <div className='dialog-report-title'>
            <Typography className='title-text'>Generate Report</Typography>
            <Typography>
              Configure data sources and timeframe. Optionally schedule this
              report to run automatically.
            </Typography>
          </div>
          <Grid style={{ marginLeft: 'auto' }}>
            <img src={close} onClick={onClose} className='image-style' />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className='dialog_content'>
        <Grid container spacing={1}>
          {/*Name */}
          <Grid item xs={6} md={6}>
            <Typography className='header_text'>
              Report Name <span className='star-style'>*</span>
            </Typography>
            <Box className='box-width'>
              <TextField
                // id='outlined-basic'
                variant='outlined'
                // size='small'
                fullWidth
                id='fullWidth'
                autoComplete='off'
                value={reportName}
                onChange={handleReportName}
                placeholder='Enter the Report Name'
                InputLabelProps={{ className: 'serachLabel' }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    height: '40px', // Sets the height of the entire input container
                  },
                }}
              />
            </Box>
            {switchEachSite && (
              <Typography className='report-name-text'>
                Report name will be automatically suffixed with the site name.
              </Typography>
            )}
          </Grid>
          <Grid item xs={6} md={6}>
            <Typography className='header_text'>
              Description <span className='star-style'>*</span>
            </Typography>
            <Box className='box-width'>
              <TextField
                fullWidth
                id='fullWidth'
                multiline
                value={description}
                onChange={handleDescription}
                placeholder='Enter the Report Description'
                sx={{
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                    alignItems: 'flex-start',
                    padding: '2px 14px',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                  },
                  '& textarea': {
                    height: 'calc(100% - 4px) !important',
                    overflowY: 'auto !important',
                    overflowX: 'hidden !important',
                    resize: 'none',
                    padding: '0',
                    boxSizing: 'border-box',
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                  },
                }}
              />
            </Box>
          </Grid>
          {/*Type */}
          <Grid item xs={6} md={6}>
            <div className='report-header-row'>
              <Typography className='header_text'>
                Report Types <span className='star-style'>*</span>
              </Typography>
              <span className='report-counter-text'>
                {reportCounter} selected
              </span>
            </div>
            <div className='report-list'>
              {report_type_list.map((item) => (
                <label key={item.label} className='report-item'>
                  <input
                    type='checkbox'
                    //checked={!!reportTypes[item]}
                    value={item.label}
                    checked={reportTypes.some((el) => el.label == item.label)}
                    onChange={(e) => {
                      handleChangeReportTypes(e, item);
                    }}
                    disabled={
                      (item.label === 'StarlinkUsage' ||
                        item.label === 'All') &&
                      switchEachSite
                    }
                  />
                  <span>{item.name}</span>
                </label>
              ))}
            </div>
          </Grid>

          <Grid item xs={6} md={6}>
            <Typography className='header_text'>Scope</Typography>
            <Grid
              container
              className='d-flex'
              spacing={1}
              flexDirection='column'
            >
              {/*Organization*/}
              <Grid item>
                <span id='content-left-text'>
                  Organization <span className='star-style'>*</span>
                </span>
                <div style={{ marginTop: '14px' }}>
                  <Org_Drop_down
                    isReports={false}
                    setOu={handleOu}
                    className={'org-drop-down'}
                    is_report_edit={is_report_edit}
                  />
                </div>
                {no_site_sl && !showLoader && (
                  <div style={{ marginTop: '8px' }}>
                    <span id='content-left-text'>
                      No Site(s) and Service Lines(s) found for the selected
                      Organization
                    </span>
                  </div>
                )}
              </Grid>

              <Grid item hidden={!site_admin_access}>
                <Typography className='header_text'>Sites</Typography>
                <Autocomplete
                  className='select-site-input'
                  fullWidth
                  size='small'
                  multiple
                  limitTags={1}
                  disableCloseOnSelect
                  ListboxProps={{
                    className: 'warehouse-apply-config-props',
                  }}
                  id='multiple-limit-tags'
                  options={_sitesList}
                  sx={{ width: '91%' }}
                  getOptionLabel={(option: any) => {
                    return option.siteName;
                  }}
                  value={[...sites]}
                  getOptionDisabled={(option: any) => {
                    let vesselOption = 'All Sites';
                    if (
                      sites.findIndex(
                        (item) => item?.siteName === vesselOption,
                      ) !== -1
                    )
                      return true;
                    if (
                      option.siteName === vesselOption &&
                      sites[0]?.siteName &&
                      sites[0]?.siteName !== vesselOption
                    )
                      return true;
                    if (sites.find((ele) => ele.siteName == option.siteName))
                      return true;
                    return false;
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.siteId}>
                      {option.siteName}
                    </li>
                  )}
                  onChange={(e, newValue) => {
                    handleChangeSite(e, newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} required className='report_name' />
                  )}
                />
                <div className='d-flex' style={{ marginTop: '10px' }}>
                  <CustomizedSwitches
                    is_checked={switchEachSite}
                    onChange={(e) => {
                      e.stopPropagation();
                      setSwitchEachSite(!switchEachSite);
                      handleChangeReportTypes(
                        { target: { checked: false } },
                        { ...starlink_label },
                      );
                    }}
                    disabled={switchScheduler || is_report_editable}
                    width={31}
                    height={17}
                    thumbWidth={12}
                    thumbHeight={12}
                  />
                  <Typography className='site-toggle-text'>
                    Generate a Report for each Site
                  </Typography>
                </div>
              </Grid>

              {/*Service Lines */}
              <Grid item hidden={!sl_admin_access}>
                <Typography className='header_text'>Service Lines</Typography>
                <Autocomplete
                  className='autocompleteText'
                  fullWidth
                  multiple
                  limitTags={1}
                  disableCloseOnSelect
                  ListboxProps={{ className: 'warehouse-apply-config-props' }}
                  size='small'
                  id='multiple-limit-tags'
                  sx={{ width: '91%' }}
                  options={_serviceLineName}
                  getOptionLabel={(option: any) => option.serviceLineName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.serviceLineId} title={option.serviceLineId !== option.serviceLineName ? option.serviceLineId : undefined}>
                      {option.serviceLineName}
                    </li>
                  )}
                  value={[...serviceLines]}
                  getOptionDisabled={(option: any) => {
                    let vesselOption = 'All Service Lines';
                    if (
                      serviceLines.findIndex(
                        (item) => item?.serviceLineName === vesselOption,
                      ) !== -1
                    )
                      return true;
                    if (
                      option.serviceLineName === vesselOption &&
                      serviceLines[0]?.serviceLineName &&
                      serviceLines[0]?.serviceLineName !== vesselOption
                    )
                      return true;
                    if (
                      serviceLines.find(
                        (ele) => ele.serviceLineId == option.serviceLineId,
                      )
                    )
                      return true;
                    return false;
                  }}
                  onChange={(e, newValue: any) => {
                    handleInputServiceLineChange(e, newValue);
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option: any, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.serviceLineId}
                        label={option.serviceLineName}
                        title={option.serviceLineId !== option.serviceLineName ? option.serviceLineId : undefined}
                        size='small'
                      />
                    ))
                  }
                  renderInput={(params) => <TextField {...params} required />}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} className='line-container'>
            <Divider className='confirm-dialogue-new-divider' />
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography className='header_text'>Timeframe</Typography>
          </Grid>
          <Grid item xs={3} md={3}>
            <Stack direction='column'>
              <span id='content-left-text' className='header_text'>
                Start Date
              </span>
              <DateFilter
                date_value={from_date}
                handleDateChange={handleFromDatePicker}
                max_date={today_date}
                _views={date_views}
                disable={switchScheduler}
              />
            </Stack>
          </Grid>
          <Grid item xs={3} md={3}>
            <Stack direction='column'>
              <span id='content-left-text' className='header_text'>
                End Date
              </span>
              <DateFilter
                date_value={to_date}
                handleDateChange={handleToDatePicker}
                max_date={today_date}
                _views={date_views}
                disable={switchScheduler}
              />
            </Stack>
          </Grid>
          <Grid item xs={3} md={3}>
            <Stack direction='column'>
              <span id='content-left-text' className='header_text'>
                Time
              </span>
              <DateFilter
                date_value={start_time}
                handleDateChange={handleStartTimePicker}
                max_date={today_date}
                _views={date_views}
                daily={true}
                max_time={(() => {
                  if (!switchScheduler && to_date != null) {
                    const tz = selectedTimeZone.split(' - ')[0];
                    const nowInTz = tz ? moment().tz(tz) : moment();
                    if (moment(to_date).isSame(nowInTz, 'day')) return nowInTz;
                  }
                  return null;
                })()}
              />
            </Stack>
          </Grid>
          <Grid item xs={3} md={3}>
            <Stack direction='column'>
              <span id='content-left-text' className='header_text'>
                Time Zone
              </span>
              <SelectTimezone
                value={getTimezoneCity(selectedTimeZone)}
                onChange={({ label, value }) => {
                  setSelectedTimeZone(label);

                  let dte = moment().tz(value);
                  setStartTime(dte);
                }}
                optionLabelFormat={(timezone) =>
                  `${timezone.name} - ${timezone.abbreviation}`
                }
                containerStyles={{ width: '90%', height: '33%' }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid
              container
              className={switchScheduler ? 'scheduler-box-on' : 'scheduler-box'}
            >
              <Grid item xs={1} md={1} className='time-clock'>
                <img
                  src={switchScheduler ? clockBlueBg : time_clock}
                  alt='clock'
                  style={{ display: 'block', marginRight: '5px' }}
                  width={switchScheduler ? '25' : '18'}
                  height={switchScheduler ? '25' : '18'}
                />
              </Grid>
              <Grid item xs={9} md={9}>
                <Stack direction='column'>
                  <Typography className='scheduler-txt'>
                    Schedule Recurrence
                  </Typography>
                  <Typography>
                    Automatically run this report on a schedule
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={2} md={2} className='switch-style'>
                <CustomizedSwitches
                  is_checked={switchScheduler}
                  onChange={(e) => {
                    e.stopPropagation();
                    setSwitchScheduler(!switchScheduler);
                  }}
                  disabled={switchEachSite}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                hidden={!switchScheduler}
                style={{ marginTop: '20px' }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={1} md={1}></Grid>
                  <Grid item xs={5} md={5}>
                    <Stack direction='column'>
                      <span id='content-left-text' className='header_text'>
                        Frequency
                      </span>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby='demo-row-radio-buttons-group-label'
                          name='row-radio-buttons-group'
                        >
                          {DEFAULT_FREQUENCIES.map((ob) => {
                            return (
                              <div className='d-flex'>
                                <Radio
                                  checked={ob.label == selectedFrequency?.label}
                                  onChange={(e) => {
                                    handleChangeFrequency(e, ob);
                                  }}
                                  disabled={
                                    is_report_editable &&
                                    !is_copy_report &&
                                    was_scheduled_on_edit
                                  }
                                />
                                <Typography style={{ marginTop: '10px' }}>
                                  {ob.name}
                                </Typography>
                              </div>
                            );
                          })}
                        </RadioGroup>
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={5} md={5}>
                    <Typography className='header_text'>
                      Recurrence Details
                    </Typography>
                    {selectedFrequency?.label !== 'daily' && (
                      <Typography className='header_text'>Run on</Typography>
                    )}
                    {selectedFrequency?.label === 'monthly' ? (
                      <div className='siteCharts__filters-date-time-picker'>
                        <DayPicker
                          width={230}
                          height={34}
                          dayOptions={days}
                          handleDayPicker={handleDayPicker}
                          day={day}
                          dayDisplayKey={'label'}
                          disableClear={true}
                          daysInMonth={daysInMonth}
                        />
                      </div>
                    ) : selectedFrequency?.label === 'weekly' ? (
                      <div className='siteCharts__filters-date-time-picker'>
                        <Autocomplete
                          options={week_days}
                          getOptionLabel={(option) => option.name || ''}
                          sx={{ width: 250 }}
                          onChange={handleWeekDay}
                          value={selWeekDay || null}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder='Select Week Type'
                              variant='outlined'
                              size='small'
                            />
                          )}
                        />
                      </div>
                    ) : (
                      <Typography className='runs-every-day'>
                        Runs every day.
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                hidden={
                  !switchScheduler ||
                  !summaryText ||
                  summaryText === undefined ||
                  summaryText.trim() === ''
                }
                style={{ marginTop: '20px' }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={1} md={1}></Grid>
                  <Grid item xs={11} md={11}>
                    <span id='content-left-text' className='header_text'>
                      {`Summary: ${summaryText}`}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className='config-create-actions'>
        <Button className='config-cancel-btn' onClick={onClose}>
          Cancel
        </Button>
        <Button
          className='config-create-btn button_style update-btn'
          onClick={(e) => {
            handleSaveButton(e);
          }}
        >
          {!is_report_editable && !switchScheduler && (
            <img
              src={runReport}
              alt='runReport'
              style={{ display: 'block', marginRight: '8px' }}
              width='20'
              height='16'
            />
          )}
          {is_report_editable && !is_copy_report
            ? `✔ Update Schedule`
            : switchScheduler
              ? `✔ Save Schedule`
              : 'Run Report'}
        </Button>
      </DialogActions>
      {showLoader && (
        <CustomLoader showLoader={true} loadingText={'Please wait...'} />
      )}
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  getAllServiceLinesSubscription:
    state.starlinkDashboard.getAllServiceLinesSubscription,
  site_admin_access: state?.authReducer?.site_admin_access,
  sl_admin_access: state?.authReducer?.sl_admin_access,
});

export default withRouter(
  connect(mapStateToProps, {
    getReportsSubscription,
    createReportsSubscription,
    updateReportsSubscription,
    fetchResources,
    getResourcesForOUs,
    getServiceLinesForOUs,
    fetchServiceLines,
    getAllServiceLineSubscriptionAPI,
  })(AddReportPopup),
);
